import { FaArrowLeft } from 'react-icons/fa';
import { AppButton } from '../Button/_index';
import { Breadcrumbs, Tabs } from '../Kit/_index';

const BLOCK = 'LStudio__app_page_head';

/*
    🔥 CABECERA DE PÁGINA

    Es lo que abre TODA vista privada: migas, título, estado, acciones
    y a veces pestañas. Hoy cada vista lo arma a mano, y por eso el
    título de una está 4px más abajo que el de la otra, una tiene el
    botón de volver y otra no.

    ⚠️ EL BOTÓN DE VOLVER NO USA EL HISTORIAL

    backTo es una RUTA, no un history.back(). Si el usuario llegó por
    un enlace pegado en un chat, "atrás" lo saca del sitio. La ruta
    padre siempre lleva a algún lugar sensato.

    ⚠️ LAS PESTAÑAS VIVEN ACÁ, NO EN EL CUERPO

    Pegadas al borde inferior de la cabecera se leen como secciones de
    ESTA página. Sueltas en el cuerpo, parecen un control más del
    contenido y compiten con los filtros.

    ⚠️ isSticky NO ES EL DEFAULT

    Una cabecera pegajosa se come 90px de alto en cada scroll. Tiene
    sentido con pestañas o con tablas largas; en un formulario corto,
    solo molesta.
*/

export const PageHeader = ({
    title,
    subtitle = null,
    description = null,
    breadcrumbs = null,          // [{ label, href }]
    status = null,               // <StatusBadge/> u otro nodo
    meta = null,                 // fecha, autor, id
    actions = null,
    backTo = null,
    backLabel = 'Volver',
    tabs = null,                 // [{ value, label, icon, badge }]
    activeTab = null,
    onChangeTab = null,
    tabsVariant = 'line',
    isSticky = false,
    variant = 'plain',           // plain | surface
    icon = null,
}) => (

    <header className={BLOCK} data-sticky={isSticky} data-variant={variant}>

        {
            breadcrumbs?.length > 0 && (
                <div className={`${BLOCK}__crumbs`}>
                    <Breadcrumbs items={breadcrumbs} maxVisible={4} />
                </div>
            )
        }

        <div className={`${BLOCK}__row`}>

            <div className={`${BLOCK}__left`}>

                {
                    backTo && (
                        <AppButton
                            className={`${BLOCK}__back`}
                            to={backTo}
                            variant="ghost"
                            tone="neutral"
                            isIconOnly
                            icon={<FaArrowLeft />}
                            aria-label={backLabel}
                        />
                    )
                }

                {icon && <span className={`${BLOCK}__icon`} aria-hidden="true">{icon}</span>}

                <div className={`${BLOCK}__text`}>

                    <div className={`${BLOCK}__title_row`}>

                        <h1 className={`${BLOCK}__title`}>{title}</h1>

                        {status}

                    </div>

                    {subtitle && <p className={`${BLOCK}__subtitle`}>{subtitle}</p>}

                    {meta && <div className={`${BLOCK}__meta`}>{meta}</div>}

                </div>

            </div>

            {actions && <div className={`${BLOCK}__actions`}>{actions}</div>}

        </div>

        {description && <p className={`${BLOCK}__description`}>{description}</p>}

        {
            tabs?.length > 0 && (
                <div className={`${BLOCK}__tabs`}>
                    <Tabs items={tabs} value={activeTab} onChange={onChangeTab} variant={tabsVariant} />
                </div>
            )
        }

    </header>
);

/*
    🔥 GRUPO DE METADATOS

    Los pares "etiqueta: valor" que van bajo el título —creado por,
    última edición, ID— separados por puntos.
*/
export const PageHeaderMeta = ({ items = [] }) => (

    <>
        {
            items.filter(Boolean).map((item, index) => (
                <span key={item.label ?? index} className={`${BLOCK}__meta_item`}>

                    {item.icon && <span aria-hidden="true">{item.icon}</span>}

                    {item.label && <em>{item.label}:</em>}

                    {item.value}

                </span>
            ))
        }
    </>
);
